<script>
import {  mapMutations, mapGetters, mapActions } from 'vuex'
import arce from '../../../services/arce'
import stepsMixin from '@/mixins/stepsMixin'
export default {
	mixins: [stepsMixin],
	components: {
		SvgIcon: () => import('@/components/SvgIcon'),
	},
	data() {
		return {
			tour: 'myTourWizardArce',
			showing: null,
			information: {
				financialSponsor: false,
				ews: false,
				checklist: false,
				eeff: false,
				code: false,
			},
			sector: null,
		}
	},
	computed: {
		...mapGetters({
			currentArce: 'arceStatus/currentArce',
			statusStep: 'arceStatus/statusStep',
			stepsArce: 'arceStatus/stepsArce',
			groupStructure: 'arceStatus/groupStructure',
			currentStep: 'arceStatus/currentStep',
			
			userId: 'auth/userId',
		})
	},
	
	methods: {
		prev() {
			let id = this.currentStep.sort
			if(this.showing) {
				if(this.showing > 1) {
					this.showing -= 1
				}
				return
			}
			this.showing = id-1 || 1
		},

		next() {
			let isValid = this.validStep()
			if(!isValid) return 
			if(this.showing) {
				if(this.showing < this.currentStep.sort) {
					this.showing += 1
					setTimeout(() => {
						this.$tours[this.tour].nextStep()
					}, 100)
					return
				}
			}
			this.showing = null

			if(isValid) {
				this.markPassedStep(this.currentStep.key)
				setTimeout(() => {
					this.$tours[this.tour].nextStep()
				}, 100)
			}
		},
		close() {
			this.hiddenSteps()
			this.hideArceWizard()
			this.resetWizardArce()
		},
		validStep() {
			let step = this.currentStep
			if(this.showing) {
				let step_s = this.stepsArce.find(s => s.sort == this.showing)

				if(step_s) {
					step = step_s
				}
			}
			
			let data = this.currentArce[step.key]
			if(!data) return false

			if(step.key == 'information') {
				let completed = true
				Object.keys(data).forEach(key => {
					if(!data[key]) {
						completed = false
					}
				});
				return completed
			}

			return true
		},
		
		updateInformation() {
			this.setInformation(this.information)
		},
		updateSector() {
			this.setSector(this.sector)
		},

		postpone() {
			let clientId = this.currentArce.client.id
			this.saveWizardArce(Object.assign({arce: {...this.currentArce}}, {userId: this.userId, status: 'postponed', steps: [...this.stepsArce]}))
			this.hideArceWizard()
			this.resetCurrentArce()
			this.resetStepsArce()
			this.$router.push({name: 'arce-client', params: {id: clientId}})
			this.hiddenSteps()
			this.showSteps('myTourClient')
		},
		async save() {
			let service = arce
			let folio = Date.now()
			this.saveWizardArce(Object.assign({arce: {...this.currentArce}}, {userId: this.userId, status: 'finished', steps: [...this.stepsArce]}))
			try {
				let data = await service.save({
					groupId: this.currentArce.groupStructure.id,
					status: 'prepair',
					folio: folio,
					userId: this.userId,
					children: [],
					arce: {},
					arceFill: {}
				})
				this.hideArceWizard()
				this.resetCurrentArce()
				this.resetStepsArce()
				this.hiddenSteps()
				this.$router.push({name: 'arce-details', params: {id: data._id}})
			} catch (error) {
				
			}
			
		},

		...mapMutations({
			showArceWizard: 'arceStatus/showArceWizard',
			hideArceWizard: 'arceStatus/hideArceWizard',
			markPassedStep: 'arceStatus/markPassedStep',
			setInformation: 'arceStatus/setInformation',
			resetCurrentArce: 'arceStatus/resetCurrentArce',
			resetStepsArce: 'arceStatus/resetStepsArce',
			setSector: 'arceStatus/setSector',
			setOperationType: 'arceStatus/setOperationType',
			resetWizardArce: 'arceStatus/resetWizardArce',
		}),
		...mapActions({
			saveWizardArce: 'arceStatus/saveArce',
			getArce: 'arceStatus/getArce'
		})
	},

	mounted() {
		
		this.getArce({
			userId: this.userId,
			'arce.client.id': this.currentArce.client.id,
			status: 'postponed'
		}).then(data => {
			this.hiddenSteps()

			if(this.currentStep.key === 'information') {
				this.tour = 'myTourWizardArcePosponed'
			} else {
				this.tour = 'myTourWizardArce'
			}
			this.showSteps(this.tour)
		})
		
	}
}
</script>
<template>
	<div class="s-wizard">
		<div class="s-wizard__wrapper">
			<button class="s-wizard__close" @click="close">
				<svg-icon name="close" />
			</button>
			<div class="s-wizard__dialog">
				<!-- <pre>{{currentArce}}</pre> -->
				<!-- <pre>{{currentArce}}</pre> -->
				<div v-if="statusStep('start') == 'current' || showing == 1">
					<div class="s-wizard__header border-bottom">
						<h1 class="text-center">ARCE Wizard</h1>
						<p class="text-center">Selección tipo ARCE</p>
					</div>
					<div class="s-wizard__body p-3">
						<p>Selecciona una operación</p>
						<div class="d-flex flex-wrap justify-content-center" data-v-step="w0-1">
							<div class="col-12 col-md-6 col-lg-4 px-2">
								<div>
									<div class="s-option-icon" :class="{'selected': currentArce.operationType == 'analysis'}" @click="setOperationType('analysis')">
										<svg-icon name="retail_execution" />
									</div>
									<div class="text-center">
										<p class="m-0">Análisis</p>
										<p class="small m-0">Crear, modificar o renovar un ARCE completo.</p>
									</div>
								</div>
							</div>
							<div class="col-12 col-md-6 col-lg-4 px-2">
								<div>
									<div class="s-option-icon" :class="{'selected': currentArce.operationType == 'rating'}" @click="setOperationType('rating')">
										<svg-icon name="rating" />
									</div>
									<div class="text-center">
										<p class="m-0">Rating como proceso independiente</p>
										<p class="small m-0">Crear Rating como proceso independiente.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div v-else-if="statusStep('groupStructure') == 'current' || showing == 2">
					<div class="s-wizard__header border-bottom">
						<h1 class="text-center">Estructura de Grupo</h1>
					</div>
					<div class="s-wizard__body p-0" data-v-step="w1">
						<p class="font-weight-bold m-0 px-3">La estructura del grupo se ha actualizado correctamente.</p>
						<table class="w-100 s-table" style="font-size: 0.9em">
							<thead style="font-size: 0.8em">
								<tr>
									<th class="py-1">Nombre del Cliente</th>
									<th class="py-1">Identificador del Cliente</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(client, index)  in currentArce.groupStructure.children"
								:key="`s-group-c-${index}-${client.id}`">
									<td class="py-1">
										{{client.name}}
									</td>
									<td class="py-1">
										{{client.code}}
									</td>
								</tr>
								<tr>
									<td class="py-1">
										{{ currentArce.groupStructure.name }}
									</td>
									<td class="py-1">
										{{ currentArce.groupStructure.code }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div v-else-if="currentArce.operationType !== 'rating'">
					<div v-if="statusStep('type') == 'current' || showing == 3">
						
						<div class="s-wizard__header border-bottom">
							<h1 class="text-center">Selecciona el tipo de análisis</h1>
						</div>
						<div class="s-wizard__body p-0">
							<div class="w-50 mx-auto">
								<p class="m-0 font-weight-bold text-center">¿Qué tipo de análisis quieres hacer?</p>
								<label class="d-block m-0" data-v-step="w2">
									<input type="radio" name="type" value="new" v-model="currentArce.type">
									<span class="ml-1">Nuevo análisis</span>
								</label>
								<label class="d-block m-0">
									<input type="radio" name="type" value="2" disabled v-model="currentArce.type">
									<span class="ml-1">Modificar análisis</span>
								</label>
								<label class="d-block m-0">
									<input type="radio" name="type" value="2" disabled v-model="currentArce.type">
									<span class="ml-1">Rating Independiente</span>
								</label>
								<label class="d-block m-0">
									<input type="radio" name="type" value="2" disabled v-model="currentArce.type">
									<span class="ml-1">Renovación</span>
								</label>
							</div>
						</div>
					</div>
					<div v-else-if="statusStep('information') == 'current' || showing == 4">
						<div class="s-wizard__header border-bottom">
							<h1 class="text-center">Información del cliente necesaria para el análisis</h1>
						</div>
						<div class="s-wizard__body p-0" >
							<p class="m-0 font-weight-bold text-center" data-v-step="w3a">Para continuar con el análisis, confirme que cuenta con la siguiente información actualizada para cada filial del Grupo que vaya a tener una Política de Riesgos.</p>
							<div class="w-50 mx-auto" data-v-step="w3">
								<label class="d-block m-0">
									<input type="checkbox" v-model="currentArce.information.financialSponsor">
									<span class="ml-1">Financial Sponsor</span>
								</label>
								<label class="d-block m-0">
									<input type="checkbox" v-model="currentArce.information.ews">
									<span class="ml-1">EWS (Early Warning System)</span>
								</label>
								<label class="d-block m-0">
									<input type="checkbox" v-model="currentArce.information.checklist">
									<span class="ml-1">Checklist Genérico y Sectorial</span>
								</label>
								<label class="d-block m-0">
									<input type="checkbox" v-model="currentArce.information.eeff">
									<span class="ml-1">EE.FF Actualizado</span>
								</label>
								<label class="d-block m-0">
									<input type="checkbox" v-model="currentArce.information.code">
									<span class="ml-1">Código de actividad del cliente</span>
								</label>
							</div>
							<div class="text-center mt-3">
								<button @click="postpone" v-if="currentStep.key === 'information'" class="s-btn s-btn--primary">
									Posponer
								</button>
							</div>
						</div>
					</div>
					<div v-else-if="statusStep('sector') == 'current' || showing == 5">
						<div class="s-wizard__header border-bottom">
							<h1 class="text-center">Sector del cliente</h1>
						</div>
						<div class="s-wizard__body p-0">
							<div class="w-75 mx-auto">
								<p class="m-0 font-weight-bold">Introduzca el sector al que pertenece el cliente</p> 
								<div>
									<label class="d-block">
										<p class="m-0">Sector del cliente</p>
										<select class="form-control w-100" data-v-step="w4" v-model="currentArce.sector">
											<option value="" disabled selected></option>
											<option value="Generico">Genérico</option>
											<option value="Contruccion">Contrucción</option>
											<option value="Agropecuario">Agropecuario</option>
											<option value="Hotelero">Hotelero</option>
											<option value="Auto Retail">Auto Retail</option>
										</select>
									</label>
								</div>
								<div class="mt-3">
									<p class="m-0 ">Financial Information is consolidated for the group?</p>
									<div class="s-tf mb-5">
										<label class="s-tf__item">
											<input type="radio" name="finicftg" value="SI">
											<span class="s-tf__btn">SI</span>
										</label>
										<label class="s-tf__item" data-v-step="w4-2">
											<input type="radio" name="finicftg" value="NO">
											<span class="s-tf__btn">NO</span>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-else-if="statusStep('finish') == 'current' || showing == 6">
						<div class="s-wizard__header border-bottom">
							<h1 class="text-center">Puede continuar al Arce</h1>
						</div>
					</div>
				</div>
				<div v-else>
					<div v-if="statusStep('type') == 'current' || showing == 3">
						<div class="s-wizard__header border-bottom">
							<h1 class="text-center">Selección de EEFF</h1>
						</div>
						<div class="s-wizard__body p-0">
							<table class="s-table w-100">
								<thead>
									<tr>
										<th>

										</th>
										<th>
											Periodo
										</th>
										<th>
											Fecha
										</th>
										<th>
											Certificado
										</th>
										<th>
											Tipo
										</th>
										<th>
											Valido par...
										</th>
										<th>
											Tipo Ajust...
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="n in 20">
										<td>
											{{n}} <input type="radio">
										</td>
										<td>
											12
										</td>
										<td>
											2019-12-31
										</td>
										<td>
											Auditado
										</td>
										<td>
											Individual
										</td>
										<td>
											Valido
										</td>
										<td>
											No Ajustado
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div class="s-wizard__footer p-3 mt-3">
					<div class="">
						<div class=" w-75 mx-auto s-step">
							<div class="d-flex w-100 s-step__road">
								<span v-for="(step, index) in stepsArce"
								:key="`step-bar-${index}`"
								class="s-step__bar"
								:class="{
									's-step__bar--passed': statusStep(step.key) == 'passed',
									's-step__bar--current': statusStep(step.key) == 'current'
								}"
								></span>
							</div>
							<div class="w-100 d-flex justify-content-between s-step__points">
								<span v-for="(step, index) in stepsArce" 
								:key="`step-modal-${index}`"
								class="s-step__item"
								:class="{
									's-step__item--passed': statusStep(step.key) == 'passed',
									's-step__item--current': statusStep(step.key) == 'current'
								}">
									<svg-icon v-if="statusStep(step.key) == 'passed'" name="check" />
								</span>
							</div>
							
						</div>
					</div>
					<div class="d-flex justify-content-between">
						<button @click="prev" class="s-btn s-btn--secondary">
							Atras
						</button>
						
						<button  v-if="statusStep('finish') != 'current'" @click="next" class="s-btn" :class="{'s-btn--secondary': !validStep(), 's-btn--primary': validStep()}">
							Siguiente
						</button>
						<button v-else @click="save" data-v-step="w5" class="s-btn s-btn--primary">
							Terminar
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	
</style>